import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";
import { ExternalLoggingConstants } from "../ExternalLoggingConstants";

export class WorldAssingmentErrorFactory extends BasicLogObjectFactory {

    private static WORLD_ASSIGNMENT_ERROR: number = 100;

    private static PARAM_ERROR_MESSAGE: string = "errorMessage";

    private _errorMessage: string;

    constructor(subErrorId: number, errorMessage: string) {
        super();
        this._subErrorId = subErrorId;
        this._errorMessage = errorMessage;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, WorldAssingmentErrorFactory.WORLD_ASSIGNMENT_ERROR.toString());
        lo.logData.set(WorldAssingmentErrorFactory.PARAM_ERROR_MESSAGE, this._errorMessage);

        return lo;
    }
}
